<button class="btn btn-link btn-copy-clipboard" (click)="copyToClipboard()">
  <cds-icon shape="copy-to-clipboard" title="Copy to clipboard"></cds-icon></button>
